export default __webpack_public_path__ + "static/media/love_struck.b7adf9b6.svg";